import React from 'react';
import { m } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../utils/checkout';
export function FinalCTA() {
  return <section className="bg-bg-secondary py-10 sm:py-14" data-id="element-68" data-mp="3mtrye73lgb1c">
      <div className="mx-auto max-w-2xl px-4 text-center sm:px-6" data-id="element-69" data-mp="3mt8sxpv4rf47">
        <h2 className="font-heading text-3xl font-bold uppercase leading-tight text-white sm:text-4xl" data-id="element-70" data-mp="3rs3akohd2xmq">
          La decisión es tuya.
        </h2>
        <div className="mx-auto mt-6 max-w-2xl space-y-3 text-left text-base leading-relaxed text-muted sm:text-center" data-id="element-71" data-mp="3dv6loskszq8h">
          <p data-id="element-72" data-mp="33uw836uuwgss">
            Puedes seguir como hasta ahora. Preparando entrenamientos desde cero cada semana, improvisando
            cuando el plan falla y llegando al pabellón con la duda de si lo que vas a hacer es lo correcto
            para tu equipo.
          </p>
          <p data-id="element-73" data-mp="124cbhn7hx6gz">O puedes llegar al martes con todo listo. Con la sesión elegida, el objetivo claro y la consigna exacta en el bolsillo.</p>
          <p className="font-semibold text-white" data-id="element-74" data-mp="q8dh2yficysr">180 sesiones. 6 tomos. 5 bonos. 7 días de garantía.</p>
          <p className="text-orange" data-id="element-75" data-mp="l9sit4jtgp6y">El precio de una cena. El valor de una temporada entera.</p>
        </div>

        <m.a href={CHECKOUT_URL} initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} className="group mx-auto mt-8 flex max-w-sm flex-col items-center gap-3 rounded-2xl border border-orange/30 bg-bg-primary p-6 text-center transition-colors hover:border-orange/60" data-id="element-76" data-mp="z16zv5u5ygbd">
          <span className="font-heading text-sm font-semibold uppercase tracking-wide text-muted" data-id="element-77" data-mp="gbik4jyvv6gl">
            🏀 El Manual del Entrenador
          </span>
          <span className="font-heading text-3xl font-bold text-white" data-id="element-78" data-mp="bdpebs1hsegu">19€</span>
          <span className="mt-2 inline-flex items-center gap-2 rounded-xl bg-orange px-6 py-3 text-sm font-semibold uppercase text-white transition-colors group-hover:bg-orange-hover" data-id="element-79" data-mp="1rnrtkcy434i3">
            Quiero el Manual
            <ArrowRightIcon size={16} className="transition-transform group-hover:translate-x-1" data-id="element-80" data-mp="kfg56b1hyap2" />
          </span>
          <span className="text-[11px] text-muted" data-id="element-81" data-mp="te1ldzjhxdmo">
            💳 Pago único · ⚡ Acceso inmediato · 🛡️ Garantía 7 días
          </span>
        </m.a>
      </div>
    </section>;
}